import ResultPagination from './ResultPagination';

export default ResultPagination;
